<template>
    <q-btn flat class="icon-wrapper"
       @click.prevent="switchFavorites()"
       :class="{ active: isFavorite }">
            <span class="icon like"></span>
            <q-tooltip anchor="top middle" self="bottom middle">
                <p v-if="!isFavorite">Добавить в избранное</p>
                <p v-if="isFavorite">Удалить из избранного</p>
            </q-tooltip>
    </q-btn>
</template>

<script>
export default {
    props: {
        productId: {
            required: true,
            type: Number
        }
    },
    computed: {
        isFavorite() {
            return this.$root.isFavorite(this.productId);
        },
    },
    methods: {
        switchFavorites() {
            this.$root.switchFavorites(this.productId)
        }
    },
}
</script>
